import { Size } from '../models/BlockComponentSettings/ImageSettings';

export const fitParent = (parent: Size, child: Size, margin?: Size): Size => {
  const m = margin || { width: 0, height: 0 };
  const p = { width: parent.width - m.width, height: parent.height - m.height };
  const parentAspectRatio = p.width / p.height;
  const childrenAspectRatio = child.width / child.height;

  if (childrenAspectRatio > parentAspectRatio) {
    return { width: p.width, height: (p.width / childrenAspectRatio) };
  }
  return { width: (p.height * childrenAspectRatio), height: p.height };
};

export enum ImageTypeValue {
  SYSTEM_IMAGE = 'system-image',
  BLOCKS_IMAGE = 'blocks-image',
}

export type ImageType = ImageTypeValue.SYSTEM_IMAGE | ImageTypeValue.BLOCKS_IMAGE;
